import { SvgIcon } from '@mui/material';
import { memo } from 'react';

function GoodsToPersonsFlow({ ...props }) {
  return (
    <SvgIcon width='24' height='24' {...props}>
      <path
        d='M8 17C4 13 8 17 4 13C3.99958 11.5008 4 13.2417 4 12C6 10 4 12 6 10C8 8 6 10 8 8C9.1787 8 11.4829 8.01171 13 8C13 9.51092 13 11.0101 13 12.0096L19.0374 12.0026L16.9192 9.90376L17.635 9.17722L21 12.5024L17.635 15.8083L16.9134 15.0818L19.0374 13.0021L13 13.0091C13 14.0085 13 15.5008 13 17C11.9886 17 9.1787 17 8 17ZM8.55159 16.0005C9.52411 16.0005 10.9886 16.0075 12 16.0005C12 15.008 12 13.4704 12 12.5093C12 11.5483 12 10.5104 12 9.01118C10.9886 9.01118 9.52411 9.00423 8.55159 9.00423C5 12.5 8.55159 9.00423 5 12.5C5 11.539 5 13.4995 5 12.5C5 11.5005 5 13.461 5 12.5C8.5 16 5 12.5603 8.55159 16.0005Z'
        stroke='none'
        fill='currentColor'
      />
    </SvgIcon>
  );
}

export default memo(GoodsToPersonsFlow);